export default "/assets/images/sneezing-face.9c4e3ca35608af8e.png";